/** Coerces a wire number — a number, or a numeric string (ptb ids arrive as either) — to a finite number, else `null`. */
export function toNumberOrNull(value: unknown): number | null {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}
